// extracted by mini-css-extract-plugin
export default {"list":"GuidelineList_list__YUnHd","ballGroup":"GuidelineList_ballGroup__teHMw","button":"GuidelineList_button__V-ljx"};